import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function SnackWarningSection() {
  return <section className="bg-[#1f2e10] text-white py-14 md:py-16 px-4 border-y border-[#c4f000]/20" data-id="element-187">
      <div className="max-w-4xl mx-auto text-center" data-id="element-188">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-[#c4f000] mb-6 leading-tight" data-id="element-189">
          Tuo figlio fa merenda tra le 700 e le 900 volte all'anno, e offrirgli
          solo biscotti confezionati, patatine o succhi industriali così tante
          volte può compromettere il suo sviluppo e la sua salute
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-gray-300 mb-6 max-w-2xl mx-auto" data-id="element-190">
          L'eccesso di zuccheri, grassi e conservanti negli alimenti
          ultra-processati non incide solo sul peso, ma anche sulla
          concentrazione, sull'energia e sul sistema immunitario.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl font-semibold text-white mb-10 max-w-2xl mx-auto" data-id="element-191">
          E sappiamo che non è questo che vuoi per tuo figlio. Ecco perché
          Merende Felici è pensato per te!
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-192">
          <CTAButton href="#pricing" data-id="element-193">
            VOGLIO ACCEDERE A MERENDE FELICI™
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}